import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  shoe: null,
  loading: false,
};

// ------------------------------
// Action Handlers
// ------------------------------
function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const shoe = data;

  return {
    ...state,
    shoe,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
